import Container from './StatisticsContainer';

export default Container;
